import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import constant from '../../../../constant';
const Index = ({ state, onChange, onSubmit, addRow, history }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>
                            <tr className="bghed">
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w150">
                                    <p>Date Audited</p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>Yard Name/ Hull No(s)</p>
                                </td>
                                <td className="hd-s2 pd10 w200">
                                    <p>Owner

                                    </p>
                                </td>

                            </tr>

                            {state.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">{index + 1}.</p>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="date"
                                                className="form-control"
                                                placeholder=""
                                                name={item.date_audited.name}
                                                value={item.date_audited.value}
                                                onChange={(e) => { onChange(item.date_audited.name, e.target.value, index) }}
                                            />
                                        </td>

                                        <td className="tb-input-value">
                                            <select
                                                type="text"
                                                className="form-control"
                                                placeholder=""
                                                name={item.ship.name}
                                                value={item.ship.value}
                                                onChange={(e) => { onChange(item.ship.name, e.target.value, index) }}
                                            >
                                                <option value={''}>Select Yard/Hull</option>
                                                {item.ship.options.map(ship => {
                                                    return (
                                                        <option value={ship.ID}>{ship.YARD_NAME}/{ship.HULL_NUMBER}</option>

                                                    )
                                                })}
                                            </select>
                                        </td>
                                        <td className="tb-input-value">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Autofill"
                                                name={item.owner.name}
                                                value={item.owner.value}

                                            />
                                        </td>
                                    </tr>
                                )
                            })}


                            <tr className="addmoreitem">
                                <td className="td-s1" colSpan={15}>
                                    <button type="button" className="btn btn-link" onClick={() => { addRow() }}>
                                        + Add New
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row mt-4">
                    <div className="col-lg-12 text-left ">
                        <button
                            type='button'
                            className="btn btn-success"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { onSubmit() }}
                        >
                            Submit
                        </button>
                        <button
                            type="button"
                            className="btn btn-danger ms-3"
                            style={{
                                backgroundImage: "linear-gradient(90deg, #6996b5, #2b5a7e)",
                                borderColor: "#2b5a7e"
                            }}
                            onClick={() => { history.push(constant.Authedcomponent.siteManagement.url) }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)